import formatDisplayDate from 'syf-js-utilities/formats/formatDisplayDate';
import getPlatform from '../helpers/getPlatform';
import { Platform } from '../services/mma-config';
import { DataAnalytics, DataObject } from './analytics/common';
export var DataType;
(function (DataType) {
    DataType["all"] = "all-available-transactions";
    DataType["loadMore"] = "transactions-load-more";
    DataType["promos"] = "promos";
    DataType["recent"] = "activity-since-last-statement";
    DataType["statementEnding"] = "statement-ending";
    DataType["transactionEnrichment"] = "transaction-enrichment";
    DataType["activityTab"] = "activity-tab";
})(DataType || (DataType = {}));
export var getActivityTabAnalyticsProps = function () {
    return {
        activity: {
            'data-type': DataType.activityTab,
            'data-reason': '',
            'data-object': DataObject.button,
            'data-analytics': DataAnalytics.clickTrackingEvent
        },
        disputes: {
            'data-type': DataType.transactionEnrichment,
            'data-reason': 'disputes-view',
            'data-object': DataObject.button,
            'data-analytics': DataAnalytics.clickTrackingEvent
        }
    };
};
export var getFilterAnalyticsProps = function (selectedDate, status) {
    var dataType = '';
    if (selectedDate === 'all' || selectedDate === 'recent') {
        dataType = DataType[selectedDate];
    }
    else {
        dataType = "".concat(DataType.statementEnding, ": ").concat(formatDisplayDate(selectedDate));
    }
    return {
        filter: {
            'data-type': dataType,
            'data-reason': 'statement-date',
            'data-object': status
                ? DataObject.dropdownExpand
                : DataObject.dropdownCollapse
        }
    };
};
export var getLoadMoreAnalyticsProps = function () {
    return {
        loadMore: {
            'data-type': DataType.loadMore,
            'data-reason': 'statement-date',
            'data-object': DataObject.button,
            'data-analytics': DataAnalytics.clickTrackingEvent
        }
    };
};
export var activityPageView = {
    pageFunction: 'activity',
    pageKind: 'activity',
    pageName: 'view'
};
// pageKind set by Peaks but not Vista
var platform = getPlatform();
var isPeaks = platform === Platform.PEAKS;
export var activityPagePreview = {
    pageFunction: 'snapshot',
    pageKind: isPeaks ? undefined : 'activity',
    pageName: 'view'
};
//# sourceMappingURL=analytics.js.map